export enum Action {
    Default,
    Create,
    Edit,
    Archive,
    ViewCode,
    Delete,
    Details,
    Restore,
    ToggleCompanyPresence
}

export enum EntityActions {
    AddNewSubCategory = 'Add Sub-Category',
    Edit = 'Edit',
    Archive = 'Archive',
    Clone = 'Clone',
    Delete = 'Delete',
    Export = 'Export',
    AddNewIndicator = 'Add Indicator',
    Move = 'Move',
    Link = 'Link',
    Copy = 'Copy',
    Restore = 'Restore',
    Details = 'Details',
    Default = 'Default',
    Cancel = 'Cancel',
    Apply = 'Apply',
    GBBPublic = 'GBBPublic',
    DiscardChanges = 'DiscardChanges',
    ClearPreview = 'ClearPreview',
    Upload = 'Upload',
    LoadToMaster = 'LoadToMaster'
}

export enum AppAction {
    Logout = 'Logout'
}
